import { Component, OnInit, OnDestroy, input, signal } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FieldControlService, IField, InputTextComponent, ButtonComponent } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-popup-message',
    templateUrl: './popup-message.component.html',
    imports: [CommonModule, ReactiveFormsModule, ButtonComponent, InputTextComponent],
    providers: [FieldControlService]
})
export class PopupMessageComponent implements OnInit, OnDestroy {
    readonly popupDispalyObj: any = input();
    desktopForm = signal<UntypedFormGroup>(new UntypedFormGroup({}));
    isMobile: boolean;
    sink = new Subscription();
    popupCallbackDetail: string[] = [];
    align: string = 'center';

    constructor(
        public bsModalRef: BsModalRef,
        private breakpointObserver: BreakpointObserver,
        private fieldService: FieldControlService
    ) {
        this.isMobile = this.breakpointObserver.isMatched('(max-width: 768px)');
        this.sink.add(
            this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((result) => {
                this.isMobile = result.matches;
            })
        );
    }

    onFieldChange(field: any) {
        if (field.type === 'email') {
            const desktopForm = this.desktopForm();
            if (desktopForm.valid && desktopForm.controls['email']) {
                this.fieldService.emailServiceValidator(desktopForm.controls['email'].value).subscribe((errors) => {
                    if (errors !== null && errors['emailService']) {
                        this.desktopForm().controls['email'].setErrors(errors);
                    }
                });
            }
        }
    }

    ngOnInit(): void {
        this.desktopForm.set(this.fieldService.toFormGroup(this.popupDispalyObj.fields as IField[]));
        const popupDispalyObj = this.popupDispalyObj;
        this.align = popupDispalyObj?.align ? popupDispalyObj.align : 'center';
    }

    ngOnDestroy(): void {
        this.sink.unsubscribe();
    }

    footerButtonAction(event: any) {
        this.popupCallbackDetail.push(event);
        const desktopForm = this.desktopForm();
        if (desktopForm.valid && desktopForm.controls['email']) {
            this.popupCallbackDetail.push(desktopForm.controls['email'].value);
        }
        this.bsModalRef.hide();
    }
}
